"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.additiveDetail = additiveDetail;
exports.additiveEdit = additiveEdit;
exports.additivePage = additivePage;
exports.additiveSave = additiveSave;
exports.toggleAdditiveStatus = toggleAdditiveStatus;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGoodsActivityAdditive';
// 编辑
function additiveEdit(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'put',
    data: data
  });
}

// 加料推荐保存
function additiveSave(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}

// 加料推荐分页
function additivePage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 加料推荐详情
function additiveDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 切换加料推荐活动状态
function toggleAdditiveStatus(additiveId, markForEnable) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/toggleStatus',
    method: 'post',
    data: {
      additiveId: additiveId,
      markForEnable: markForEnable
    }
  });
}